import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Item } from '@/redux/back-dashboard-api';

export const getItemCategoryI18nKey = (category: Item['category']) =>
  `label.item.categories.${category}`;

export const ItemCategoryTextBadge = memo<{
  category: Item['category'];
}>(function ItemCategoryTextBadge({ category }) {
  // Hooks
  const { t } = useTranslation();

  return t(getItemCategoryI18nKey(category));
});
